export default "__VITE_ASSET__DmmbQ62F__"